import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import { RemoveItemModalFooter, RemoveItemModalText } from '../../assessment/components/ecosystemData/style'
import { defaultThreatsOptions } from './threats'

const RemoveThreatModal = ({ closeModal, confirmRemove, item }) => {
  const threats = item.Level3ThreatId ? defaultThreatsOptions.level3Threats : defaultThreatsOptions.level2Threats
  const threatItemId = item.Level3ThreatId ? item.Level3ThreatId : item.Level2ThreatId
  const name = threats.find((element) => {
    return element.value === threatItemId
  })

  return (
    <>
      <RemoveItemModalText data-test="modal-body">
        <FormattedMessage id="removeModalText" values={{ name: <b>{name ? name.label : item.name}</b> }} />
      </RemoveItemModalText>
      <RemoveItemModalFooter>
        <Button type="secondary" onClick={closeModal}>
          <FormattedMessage id="cancel" />
        </Button>
        <Button type="destructive" onClick={confirmRemove}>
          <FormattedMessage id="yesRemove" />
        </Button>
      </RemoveItemModalFooter>
    </>
  )
}

export default RemoveThreatModal

RemoveThreatModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmRemove: PropTypes.func.isRequired,
  item: PropTypes.shape({
    Level1ThreatId: PropTypes.number,
    Level2ThreatId: PropTypes.number,
    Level3ThreatId: PropTypes.number,
    name: PropTypes.string
  }).isRequired
}
